import { render, staticRenderFns } from "./CopyRightLabel.vue?vue&type=template&id=c545f374"
import script from "./CopyRightLabel.vue?vue&type=script&lang=js"
export * from "./CopyRightLabel.vue?vue&type=script&lang=js"
import style0 from "./CopyRightLabel.vue?vue&type=style&index=0&id=c545f374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports